﻿import m from 'mithril';
import { UnitTypes } from '../../admin/values';
import UnitUtilities from '../../shared/utilities/unit_utilities';
import Component_Unit_Actions_Scorm from './component_unit_actions_scorm';
import Component_Unit_Actions_Form from './component_unit_actions_form';
import Component_Unit_Actions_Event from './component_unit_actions_event';
import Component_Unit_Actions_Document from './component_unit_actions_document';
import Component_Unit_Actions_Certificate from './component_unit_actions_certificate';
import Component_Unit_Actions_Approval from './component_unit_actions_approval';
import Component_Unit_Actions_Download from './component_unit_actions_download';
import Component_Unit_Actions_Upload from './component_unit_actions_upload';
import i18n from '../../shared/i18n/i18n';


function mountButtons(dom, vnode) {
    if (vnode.attrs.unit.enrolment || vnode.attrs.unit.type === UnitTypes.event)
        m.mount(dom, {
            view: function () {
                return m(vnode.attrs.view, {
                    unit: vnode.attrs.unit,
                    course: vnode.attrs.course,
                    reloadCallback: vnode.attrs.reloadCallback
                });
            }
        });

}

const Component_Unit_List_Item = {
    view: function (vnode) {
        let unit = vnode.attrs.unit;
        let course = vnode.attrs.course;
        let unitNumber = vnode.attrs.unitNumber;
        return unit ?
            m('.SecondaryTheme tile',
                m('.padding', [
                    m('.flex-row mr-2', [
                        unit.enrolment && unit.enrolment.isCompleted && unit.enrolment.isPassed ? m('.unit-status-icon passed', m('i.icon-check'))
                            : unit.enrolment && unit.enrolment.isCompleted && !unit.enrolment.isPassed ? m('.unit-status-icon failed', m('i.icon-x'))
                                : unit.loading ? m('.unit-status-icon loading', m('i'))
                                    : unit.type === UnitTypes.approval && unit.enrolment ? [
                                        unit.enrolment.isViewed ? m('.unit-status-icon', { title: 'Viewed' }, m('i.icon-visible'))
                                            : unit.enrolment.submitted ? m('.unit-status-icon', { title: 'Pending Approval' }, m('i.icon-clock'))
                                                : ''
                                    ] : '',
                        m('div', [
                            m('.unitId', { name: unit.id }),
                            m('.tile__title', unit.name),
                            m('.tile__subtitle', UnitUtilities.getUnitTypeName(unit.type)),
                        ]),
                    ]),
                    m('.btn-padding', unit ? [
                        unit.type === UnitTypes.scorm ? m(Component_Unit_Actions_Scorm, {
                                unit: unit,
                                unitNumber: unitNumber,
                                course: course,
                                reloadCallback: vnode.attrs.reloadCallback
                            })
                            : unit.type === UnitTypes.form ? m(Component_Unit_Actions_Form, {
                                    unit: unit,
                                    unitNumber: unitNumber,
                                    course: course,
                                    reloadCallback: vnode.attrs.reloadCallback
                                })
                                : unit.type === UnitTypes.event ? m(Component_Unit_Actions_Event, {
                                        unit: unit,
                                        unitNumber: unitNumber,
                                        course: course,
                                        reloadCallback: vnode.attrs.reloadCallback,
                                    })
                                    : unit.type === UnitTypes.doc ? m(Component_Unit_Actions_Document, {
                                            unit: unit,
                                            unitNumber: unitNumber,
                                            course: course,
                                            reloadCallback: vnode.attrs.reloadCallback
                                        })
                                        : unit.type === UnitTypes.cert ? m(Component_Unit_Actions_Certificate, {
                                                unit: unit,
                                                unitNumber: unitNumber,
                                                course: course,
                                                reloadCallback: vnode.attrs.reloadCallback
                                            })
                                            : unit.type === UnitTypes.approval ? m(Component_Unit_Actions_Approval, {
                                                    unit: unit,
                                                    unitNumber: unitNumber,
                                                    course: course,
                                                    reloadCallback: vnode.attrs.reloadCallback
                                                })
                                                : unit.type === UnitTypes.download ? m(Component_Unit_Actions_Download, {
                                                        unit: unit,
                                                        unitNumber: unitNumber,
                                                        course: course,
                                                        reloadCallback: vnode.attrs.reloadCallback
                                                    })
                                                    : unit.type === UnitTypes.upload ? m(Component_Unit_Actions_Upload, {
                                                            unit: unit,
                                                            unitNumber: unitNumber,
                                                            course: course,
                                                            reloadCallback: vnode.attrs.reloadCallback
                                                        })
                                                        : [m('div', i18n.t('invalid_unit_type')),]
                    ] : '')
                ]),
            ) : '';
    }
};
export default Component_Unit_List_Item;
